/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    },
    {
        id   : 'user',
        title: 'User',
        type : 'collapsable',
        icon : 'heroicons_outline:user',
        children: [
            {
                id   : 'user.users',
                title: 'BYD Users',
                type : 'basic',
                link : '/users',
                exactMatch: true
            },
            {
                id   : 'user.applicant-user',
                title: 'Applicant Users',
                type : 'basic',
                link : 'users/applicant-user',
                exactMatch: true
            },
            {
                id   : 'user.partner-users',
                title: 'Partner Users',
                type : 'basic',
                link : '/partners/partner-user',
                exactMatch: true
            }
        ]
    },
    {
        id   : 'partner',
        title: 'Partner',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'partner.partners',
                title: 'Partners',
                type : 'basic',
                link : '/partners',
                exactMatch: true
            },
            // {
            //     id   : 'partner.partner-users',
            //     title: 'Partner Users',
            //     type : 'basic',
            //     link : '/partners/partner-user',
            //     exactMatch: true
            // }
        ]
    },
    {
        id   : 'loan',
        title: 'Loan',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'loan.loanApplications',
                title: 'Loan Applications',
                type : 'basic',
                link : '/loans',
                exactMatch: true
            },
            {
                id   : 'loan.activeLoans',
                title: 'Active Loans',
                type : 'basic',
                link : '/loans/active-loans',
                exactMatch: true
            },
            {
                id   : 'loan.cloedLoans',
                title: 'Closed Loans',
                type : 'basic',
                link : '/loans/closed-loans',
                exactMatch: true
            },
            {
                id   : 'lead.leadApplications',
                title: 'New Leads/Holds/Stalled',
                type : 'basic',
                link : '/leads',
                exactMatch: true
            },
            {
                id   : 'loan.legacyLoans',
                title: 'Legacy Loans',
                type : 'basic',
                link : '/legacy-loans',
                exactMatch: true
            }
        ]
    },
    {
        id   : 'governmentFee',
        title: 'Fee',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'governmentFee.UscisFee',
                title: 'USCIS Fee',
                type : 'basic',
                link : '/uscisFee'
            }
        ]
    },
    {
        id   : 'report',
        title: 'Report',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'report.loanStatusReport',
                title: 'Partner Report',
                type : 'basic',
                link : '/report/loanStatusReport'
            },
            {
                id   : 'report.dailyReport',
                title: 'Daily Report',
                type : 'basic',
                link : '/report/dailyReport'
            },
            {
                id   : 'report.masterReport',
                title: 'Master Report',
                type : 'basic',
                link : '/report/masterReport'
            }
        ]
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];

//adding navigation for relationship manager role
export const relationshipManagerNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    },
    {
        id   : 'user',
        title: 'User',
        type : 'collapsable',
        icon : 'heroicons_outline:user',
        children: [
            {
                id   : 'user.applicant-user',
                title: 'Applicant Users',
                type : 'basic',
                link : 'users/applicant-user',
                exactMatch: true
            }
        ]
    },
    {
        id   : 'loan',
        title: 'Loan',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'loan.loanApplications',
                title: 'Loan Applications',
                type : 'basic',
                link : '/loans'
            },
            {
                id   : 'loan.activeLoans',
                title: 'Active Loans',
                type : 'basic',
                link : '/loans/active-loans'
            },
            {
                id   : 'loan.cloedLoans',
                title: 'Closed Loans',
                type : 'basic',
                link : '/loans/closed-loans',
                exactMatch: true
            },
            {
                id   : 'lead.leadApplications',
                title: 'New Leads/Holds/Stalled',
                type : 'basic',
                link : '/leads',
                exactMatch: true
            }
        ]
    },
    {
        id   : 'report',
        title: 'Report',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'report.loanStatusReport',
                title: 'Partner Report',
                type : 'basic',
                link : '/report/loanStatusReport'
            },
            {
                id   : 'report.dailyReport',
                title: 'Daily Report',
                type : 'basic',
                link : '/report/dailyReport'
            }
        ]
    }
];

//adding navigation for underwriting role
export const underwritingNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    },
    {
        id   : 'loan',
        title: 'Loan',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'loan.loanApplications',
                title: 'Loan Applications',
                type : 'basic',
                link : '/loans'
            },
            {
                id   : 'loan.activeLoans',
                title: 'Active Loans',
                type : 'basic',
                link : '/loans/active-loans'
            },
            {
                id   : 'loan.cloedLoans',
                title: 'Closed Loans',
                type : 'basic',
                link : '/loans/closed-loans',
                exactMatch: true
            },
            {
                id   : 'lead.leadApplications',
                title: 'New Leads/Holds/Stalled',
                type : 'basic',
                link : '/leads',
                exactMatch: true
            }
        ]
    }
];

//adding navigation for operations role
export const operationsNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    },
    {
        id   : 'loan',
        title: 'Loan',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'loan.loanApplications',
                title: 'Loan Applications',
                type : 'basic',
                link : '/loans'
            },
            {
                id   : 'loan.activeLoans',
                title: 'Active Loans',
                type : 'basic',
                link : '/loans/active-loans'
            },
            {
                id   : 'loan.cloedLoans',
                title: 'Closed Loans',
                type : 'basic',
                link : '/loans/closed-loans',
                exactMatch: true
            },
            {
                id   : 'lead.leadApplications',
                title: 'New Leads/Holds/Stalled',
                type : 'basic',
                link : '/leads',
                exactMatch: true
            }
        ]
    },
    {
        id   : 'partner',
        title: 'Partner',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'partner.partners',
                title: 'Partners',
                type : 'basic',
                link : '/partners',
                exactMatch: true
            }
        ]
    }
];

export const partnerAdminNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    },
    {
        id   : 'partner',
        title: 'Partner',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'partner.partners',
                title: 'Partners',
                type : 'basic',
                link : '/partners',
                exactMatch: true
            }
        ]
    },
    {
        id   : 'loan',
        title: 'Loan',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'loan.loanApplications',
                title: 'Loan Applications',
                type : 'basic',
                link : '/loans'
            },
            {
                id   : 'loan.activeLoans',
                title: 'Active Loans',
                type : 'basic',
                link : '/loans/active-loans'
            },
            {
                id   : 'loan.cloedLoans',
                title: 'Closed Loans',
                type : 'basic',
                link : '/loans/closed-loans',
                exactMatch: true
            }
        ]
    },
    {
        id   : 'report',
        title: 'Report',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'report.loanStatusReport',
                title: 'Partner Report',
                type : 'basic',
                link : '/report/loanStatusReport'
            },
            {
                id   : 'report.dailyReport',
                title: 'Daily Report',
                type : 'basic',
                link : '/report/dailyReport'
            }
        ]
    }
];

export const billingNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    },
    {
        id   : 'loan',
        title: 'Loan',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'loan.loanApplications',
                title: 'Loan Applications',
                type : 'basic',
                link : '/loans'
            },
            {
                id   : 'loan.activeLoans',
                title: 'Active Loans',
                type : 'basic',
                link : '/loans/active-loans'
            },
            {
                id   : 'loan.cloedLoans',
                title: 'Closed Loans',
                type : 'basic',
                link : '/loans/closed-loans',
                exactMatch: true
            }
        ]
    },
    {
        id   : 'report',
        title: 'Report',
        type : 'collapsable',
        icon : 'heroicons_outline:chart-pie',
        children: [
            {
                id   : 'report.loanStatusReport',
                title: 'Partner Report',
                type : 'basic',
                link : '/report/loanStatusReport'
            },
            {
                id   : 'report.dailyReport',
                title: 'Daily Report',
                type : 'basic',
                link : '/report/dailyReport'
            }
        ]
    }
];
